// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Dominican Republic */
const DO = /^(?:8[024]9[2-9]\d{6})$/;

export default DO;
